<template>
  <section class="grid-flex">
    <section class="flex column w100">
      <div class="flex-1 flex row w100 middle">
        <div class="flex-1 w100">
          <div class="flex flex-1  middle">
            <div class="button primary" @click="openModalCreate()">
              Criar Anotação
            </div>
          </div>
        </div>
        <div class="flex-1 flex end filters-groupo-holder">
          <div class="flex between middle">
            <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
          </div>
        </div>
      </div>
      <div class="flex w100 end">
        <div class="filters-groupo-holder">
          <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
      <div class="list-itens flex column w100">
        <div
          class="box flex-1 w100"
          v-for="(lg, index) in logs"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <p>
                      {{ lg.created_at | date }}
                    </p>
                  </div>
                  <div class="flex-2">
                    <div class="flex details between">
                      <div class="flex column">
                        <div>
                          Descrição
                        </div>
                        <div class="margin-top-s" style="max-width: 590px; line-break: anywhere">
                          <p>{{ lg.description }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action">
                <div class="flex end">
                  <div class="button primary" @click="openToEdit(lg)">
                    EDITAR
                  </div>
                  <div
                    class="button primary"
                    @click="openToDelete(lg)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum log criado. Crie seu primeiro Log para ter registro de atividade.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Descrição da Anotação</label>
              <textarea
                class="input margin-top-m"
                id="name"
                type="text"
                style="height: 301px; width: 512px;"
                v-model="newLog.description"
                autocomplete="off"
              />
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdateLog()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Log?"
      @cancel="
        showModalDelete = false;
        selectedLog = null;
      "
      @accept="deleteTimeLineLog(selectedLog.id)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import {
  getTimeLineLogs,
  createTimeLineLog,
  updateTimeLineLog,
  deleteTimeLineLog,
} from "@/services/timelinelog";

const EMPTY_LOG = {
  description: "",
};

export default {
  name: "time-line-log",
  components: {
    Modal,
    ModalConfirm,
    ltkDatePicker,
  },
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedLog: null,
      newLog: Object.assign({}, EMPTY_LOG),
      logs: [],
      reportShortLinks: {},
      totalLogs: 0,
      offset: 20,
      page: 1,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
      openUtmFields: false,
    };
  },
  mounted() {
    this.getTimeLineLogs();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.logs = [];
        this.reportShortLinks = {};
        this.getTimeLineLogs();
      },
    },
    page: {
      handler() {
        this.logs = [];
        this.getTimeLineLogs();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Anotação': 'Criar Anotação'
    },
    isEmpty() {
      return this.totalLogs === 0 && !this.loading;
    },
    isEdit() {
      if (this.newLog && this.newLog.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalLogs % this.offset;
      let value = this.totalLogs / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  methods: {
    openModalCreate() {
      this.showModalCreateOrUpdate = true
    },
    openToDelete(lg) {
      this.showModalDelete = true;
      this.selectedLog = lg;
    },
    openToEdit(lg) {
      this.showModalCreateOrUpdate = true;
      this.newLog = lg;
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newLog = Object.assign({}, EMPTY_LOG);
    },
    saveOrUpdateLog() {
      if (this.isEdit) {
        this.updateTimeLineLog(this.newLog.id);
      } else {
        this.createTimeLineLog();
      }
      this.closeToEdit();
    },
    getTimeLineLogs() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };
      getTimeLineLogs(params)
        .then((result) => {
          this.logs = result.logs;
          this.totalLogs = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createTimeLineLog() {
      let params = {
        description: this.newLog.description,
      };
      createTimeLineLog(params)
        .then((result) => {
          this.logs.push(result);
          this.totalLogs = this.totalLogs + 1

          this.$toast.success({
            title: "Sucesso",
            message: "Log criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateTimeLineLog(logId) {
      let params = {
        description: this.newLog.description,
      };

      updateTimeLineLog(logId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Log editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteTimeLineLog(shortId) {
      deleteTimeLineLog(shortId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Log deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedLog = null;
          this.showModalDelete = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

</style>
